import { useCallback } from 'react';
import { Group, Button } from '@mantine/core';
import Text from '@ui/components/Text/Text';
import useCurrentUserProjectPermissions from '@projectMembers/hooks/useCurrentUserProjectPermissions';
import useRequestUpgradeRoleMutation from '@projects/queries/useRequestUpgradeRoleMutation';
import { trackManagerPermissionsUpgradeRequested } from 'src/services/tracker/trackers/projects';
import { UPGRADE_REQUEST_SOURCES } from 'src/new_arch/modules/projectView/components/OverviewPermissionTooltip/upgradeRequestSources';
import GuestHash from '@projects/models/guestHash';

import Project from '../../../../../entities/project';

import InviteLinks from './InviteLinks/InviteLinks';

export type ShareInviteLinkProps = {
	project : Project;
	onInviteLinkChange?: ( guestHash: GuestHash ) => void;
};

const ShareInviteLink = ( { project, onInviteLinkChange }: ShareInviteLinkProps ) => {
	const permissions = useCurrentUserProjectPermissions( project.id );
	const currentUserCanShareInviteLink = permissions.currentUserCan( 'shareInviteLink', 'projects' );
	const { mutate: requestUpgradeRole } = useRequestUpgradeRoleMutation();

	const onRequestPermissionClick = useCallback( () => {
		trackManagerPermissionsUpgradeRequested( {
			projectID: project.id, origin: UPGRADE_REQUEST_SOURCES.PUBLIC_LINK_SHARING
		} );
		requestUpgradeRole( { projectID: project.id, source: UPGRADE_REQUEST_SOURCES.PUBLIC_LINK_SHARING } );
	}, [ requestUpgradeRole, project.id ] );

	if ( !currentUserCanShareInviteLink ) {
		return (
			<Group spacing={8} position="apart" bg="var(--color-bg-surface-container-blue)" p={12} style={{ borderRadius: 4 }}>
				<Text variant="footnote" color="var(--color-text-primary)">
					Only managers can enable and send share links
				</Text>
				<Button h={19} variant="subtle" color="primary.5" size="xs" w="fit-content" compact p={0} onClick={onRequestPermissionClick}>
					Request permission
				</Button>
			</Group>
		);
	}

	return (
		<InviteLinks
			project={project}
			onInviteLinkChange={onInviteLinkChange}
		/>
	);
};

export default ShareInviteLink;
